//申请权限
export const applyRouter = [
  {
    path: "/",
    component: () =>
      import(/* webpackChunkName: 'home' */ "../page/localCase/applyList")
  },
  {
    //远程申请
    path: "/applyList",
    component: () =>
      import(/* webpackChunkName: 'home' */ "../page/localCase/applyList")
  },
  {
    //申请单
    path: "/applyForm",
    component: () =>
      import(/* webpackChunkName: 'home' */ "../page/localCase/applyForm")
  },
  {
    //批量申请-选择病例
    path: "/batchApplyList",
    component: () =>
      import(/* webpackChunkName: 'home' */ "../page/localCase/batchApplyList")
  },
  {
    //批量申请-完善病例
    path: "/batchApplyForm",
    component: () =>
      import(/* webpackChunkName: 'home' */ "../page/localCase/batchApplyForm")
  },
  {
    //选择医院
    path: "/selectHosp",
    component: () =>
      import(/* webpackChunkName: 'home' */ "../page/localCase/selectHosp")
  },
  {
    //确认订单
    path: "/detminOrder",
    component: () =>
      import(/* webpackChunkName: 'home' */ "../page/localCase/detminOrder")
  },
  {
    //支付
    path: "/order",
    component: () =>
      import(/* webpackChunkName: 'home' */ "../page/localCase/order")
  }
];
//诊断权限
export const diagRouter = [
  {
    //诊断列表
    path: "/remoteDiag",
    component: () =>
      import(/* webpackChunkName: 'home' */ "../page/remoteCase/remoteDiag")
  },
  {
    //诊断详情
    path: "/diagDetail",
    component: () =>
      import(/* webpackChunkName: 'home' */ "../page/remoteCase/diagDetail")
  },
  {
    //收藏
    path: "/collect",
    component: () =>
      import(/* webpackChunkName: 'home' */ "../page/collect/remoteDiag")
  }
];
//审核权限
export const checkRouter = [
  {
    //审核列表
    path: "/remoteAudit",
    component: () =>
      import(/* webpackChunkName: 'home' */ "../page/remoteCase/remoteAudit")
  },
  {
    //审核详情
    path: "/auditDetail",
    component: () =>
      import(/* webpackChunkName: 'home' */ "../page/remoteCase/auditDetail")
  }
];
//本地诊断
export const localDiagRouter = [
  {
    //本地诊断
    path: "/localDiag",
    component: () =>
      import(/* webpackChunkName: 'home' */ "../page/localCase/localDiag")
  },
  {
    //诊断详情页
    path: "/formDetail",
    component: () =>
      import(/* webpackChunkName: 'home' */ "../page/localCase/formDetail")
  }
];
//管理员权限
export const adminRouter = [
  {
    //医院管理
    path: "/hospAdmin",
    component: () =>
      import(/* webpackChunkName: 'home' */ "../page/admin/hospAdmin")
  },
  {
    //医生管理
    path: "/docAdmin",
    component: () =>
      import(/* webpackChunkName: 'home' */ "../page/admin/docAdmin")
  },
  {
    //交易记录
    path: "/recordList",
    component: () =>
      import(/* webpackChunkName: 'home' */ "../page/admin/recordList")
  },
  {
    //确认订单
    path: "/accOrder",
    component: () =>
      import(/* webpackChunkName: 'home' */ "../page/admin/accOrder")
  },
  {
    //下级医院列表
    path: "/upHospList",
    component: () =>
      import(/* webpackChunkName: 'home' */ "../page/admin/upHospList")
  }
];
//远程管理员权限
export const remoteAdminRouter = [
  //单独判断
  {
    //全院病历列表
    path: "/remoteAll",
    component: () =>
      import(/* webpackChunkName: 'home' */ "../page/remoteCase/remoteAll")
  },
  {
    //全院病历列表
    path: "/allDetail",
    component: () =>
      import(/* webpackChunkName: 'home' */ "../page/remoteCase/allDetail")
  }
];
//通用
export const commonRouter = [
  {
    //检查列表
    path: "/checkList",
    component: () =>
      import(/* webpackChunkName: 'home' */ "../page/localCase/checkList")
  },
  {
    //检查列表详情页
    path: "/checkDetail",
    component: () =>
      import(/* webpackChunkName: 'home' */ "../page/localCase/checkDetail")
  },
  {
    path: "/personal",
    component: () => import(/* webpackChunkName: 'home' */ "../page/personal")
  }
];



// WEBPACK FOOTER //
// ./src/router/routerTable.js